export default "__VITE_ASSET__r8Y74d$0__"